import React, { Component } from "react";
import { connect } from "react-redux";
import { FaCloudUploadAlt } from "react-icons/fa";
import ReactDropzone from "react-dropzone";
import Api from "../../services/api";
import * as Actions from "../../actions/UploadAction";
import "./style.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import store from "../../store";

let token = "";
let fiscalYear = "";
let ministry_id = "";
// if (JSON.parse(localStorage.getItem("user"))) {
//   fiscalYear = JSON.parse(localStorage.getItem("user")).user.fiscal_year_id;
//   token = JSON.parse(localStorage.getItem("user")).token;
//   ministry_id = JSON.parse(localStorage.getItem("user")).user.ministry_id;
// }

class FileUpload extends Component {

  constructor(props) {
    super(props);
    if (JSON.parse(localStorage.getItem("user"))) {
      fiscalYear = JSON.parse(localStorage.getItem("user")).user.fiscal_year_id;
      token = JSON.parse(localStorage.getItem("user")).token;
      ministry_id = JSON.parse(localStorage.getItem("user")).user.ministry_id;
    }
  }
  onDrop = async (files) => {
    const state = store.getState();
    const authToken = state.upload;
    const url = window.location.href;
    const urlsplit = url.split("/")[url.split("/").length - 2];
    console.log("url", sessionStorage.getItem("provinceId"));
    // let { onUploaded, onLogin } = this.props;
    let {
      auth: { token },
    } = store.getState();
    const { document, toggleLoader, gnid, onUploaded } = this.props;
    // POST to a test endpoint for demo purposes
    toggleLoader && toggleLoader();
    let response;
    if (urlsplit === "selfevaluationform") {
      response = await Api.uploadProvincialDocument(
        files,
        fiscalYear,
        token,
        document.id,
        JSON.parse(localStorage.getItem("user")).user.ocmcm_id
      );
    } else {
      response = await Api.uploadDocument(
        files,
        fiscalYear,
        token,
        document.id,
        ministry_id ? ministry_id : 0
      );
    }

    toggleLoader && toggleLoader();
    // if (response.code === 200) {
    // toast("You File was uploaded", {
    //   position: "top-right",
    //   autoClose: 3000,
    //   hideProgressBar: true,
    //   closeOnClick: true,
    //   pauseOnHover: false,
    //   draggable: true,
    //   progress: undefined,
    //   type: toast.TYPE.SUCCESS
    // })
    onUploaded(document, response);
    // } else {
    //   toast("Something went wrong, Please try again.", {
    //     position: "top-right",
    //     autoClose: 3000,
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: false,
    //     draggable: true,
    //     progress: undefined,
    //     type: toast.TYPE.ERROR,
    //   });
    // }
    //TODO Feedback

    // if(response.status==="success") {
    //   setAnwerDocs(documentId, response.url);

    //   // this.notify("successToast", response)
    // } else {
    //   // this.notify("errorToast")
    // }
  };

  notify(toastId, response) {
    if (toastId === "successToast") {
      toast.success(response.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  render() {
    return (
      <div>
        <ReactDropzone
          onDrop={this.onDrop}
          className="upload-drop"
          multiple={false}
        >
          {/* <ToastContainer /> */}
          <div className="upload-box">
            <FaCloudUploadAlt />
            <span className="upload-text">अपलोड गर्नुहोस्</span>
          </div>
        </ReactDropzone>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  responseImage: auth.response,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FileUpload);
